<div class="row">
  <inspection-view *ngIf="inspection" [inspection]="inspection" (toggleCancel)="cancel()"></inspection-view>
</div>
